import React from 'react';
import { map, noop } from 'lodash';
import classnames from 'classnames';
import shortid from 'shortid';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { WIDGET_NAMES } from 'constants/entity-names';
import { MemberDetailsEligibilityWidget } from 'ui/containers/MemberDetailsEligibilityWidget';
import { MemberDetailsHeaderWidget } from 'ui/containers/MemberDetailsHeaderWidget';
import { MemberDetailsEntitiesWidget } from 'ui/containers/MemberDetailsEntitiesWidget';
import { MemberDetailsCommunicationHistoryWidget } from 'ui/containers/MemberDetailsCommunicationHistoryWidget';
import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { MemberInfoSettings } from 'ui/containers/MemberInfoSettings';
import { MemberHealthInfo } from 'ui/containers/MemberHealthInfo';

// import { MemberDetailAssistiveActionsNavWidget } from 'ui/containers/MemberDetailAssistiveActionsNavWidget';
import { MemberManagementEligibilityHistory } from 'ui/containers/MemberManagementEligibilityHistory';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.MEMBER_DETAILS_HEADER ]: MemberDetailsHeaderWidget,
    [ WIDGET_NAMES.MEMBER_DETAILS_ENTITIES ]: MemberDetailsEntitiesWidget,
    [ WIDGET_NAMES.MEMBER_DETAILS_ELIGIBILITY ]: MemberDetailsEligibilityWidget,
    [ WIDGET_NAMES.MEMBER_INFO_SETTINGS ]: MemberInfoSettings,
    [ WIDGET_NAMES.MEMBER_HEALTH_INFO ]: MemberHealthInfo,
    [ WIDGET_NAMES.MEMBER_DETAILS_COMMUNICATION_HISTORY ]: MemberDetailsCommunicationHistoryWidget,
    [ WIDGET_NAMES.MEMBER_DETAILS_ELIGIBILITY_HISTORY ]: MemberManagementEligibilityHistory
};

/*******************************/

// success view
export const memberManagementWidgetSuccess = ( props ) => {
    
    return (
        <div className='ui-member-details-widget'>
            {
                map( props.widgets, widget => {

                    // get widget view
                    const WidgetView = WIDGET_VIEWS[ widget.name ];
                    
                    // widget class name
                    const widgetClassName = classnames( 'ui-member-details-widget__widget', `ui-member-details-widget__widget--name-${ widget.name }` );

                    // create unique React key using `refreshKey` (for other than quick-actions widget)
                    const reactKey = widget.name === WIDGET_NAMES.MEMBER_DETAILS_HEADER ? widget.name : `${ props.refreshKey }__${ widget.name }`;

                    return (
                        <div key={ reactKey } className={ widgetClassName }>
                            <WidgetView
                                widget={ widget }
                                memberId={ props.memberId }
                                onGenerateActionListLog={ props.onGenerateActionListLog }
                                requestPayload={ props.requestPayload }
                                
                                // onMemberSwitch={ props.onMemberSwitch }
                            />
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
memberManagementWidgetSuccess.displayName = 'memberManagementWidget';

// set default props
memberManagementWidgetSuccess.defaultProps = {
    widgets: [],
    onMemberSwitch: noop,
    memberId: null,
    refreshKey: shortid.generate(),
    requestPayload: {},
};

// prop types
memberManagementWidgetSuccess.propTypes = {};

/*******************************/

// preloader view
export const memberManagementWidgetPreloader = () => {
    return (
        <div className='ui-member-details-widget-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
memberManagementWidgetPreloader.displayName = 'memberManagementWidgetPreloader';

// set default props
memberManagementWidgetPreloader.defaultProps = {};

// prop types
memberManagementWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberManagementWidget as MemberManagementWidget } from 'ui/views/widgets/memberManagementWidget';
 *
 * // render
 * <MemberManagementWidget propName='propValue'/>
 */
export const memberManagementWidget = withNetworkState( memberManagementWidgetPreloader, memberManagementWidgetSuccess );
